import { Alert, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';

interface Props {
  name: string;
  publishing: () => void;
}

function NotPublishedBanner({ name, publishing }: Props) {
  return (
    <div className="max-w-clientPortalMaxWidth mx-auto px-2.5 lg:px-12 my-6">
      <Alert
        status="warning"
        variant="outlined"
        icon
        radius="md"
        data-intercom-target="shareable-links-not-published-banner"
      >
        <div className="flex w-full flex-wrap items-center gap-x-4 gap-y-2">
          <div className="min-w-0 flex-1">
            <Typography variant="bodyMedium" fontWeight="medium">
              <T kind="Collection not Published" />
            </Typography>
            <Typography variant="bodySmall" className="text-muted-foreground">
              <T
                kind="The {{name}} collection is not published. Participants will not have access using the Course Deep Links."
                name={name}
              />
            </Typography>
          </div>
          <Button
            className="rounded-md bg-primary px-6 py-2 text-primary-foreground"
            value="Publish Collection"
            onClick={publishing}
            type="button"
          />
        </div>
      </Alert>
    </div>
  );
}

export default observer(NotPublishedBanner);
